import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useParams } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { checkPasswordStrength } from '@utils/Util';

const ResetPassword = ({ openModal, onCloseModal }) => {
	const [inputData, setInputData] = useState({});
	const [errors, setErrors] = useState({});
	const [passStrengthObj, setPassStrengthObj] = useState({
		percentage: '0',
		color: '',
		text: ''
	});
	const [loading, setLoading] = useState(false);
	const params = useParams();

	const validate = () => {
		let flag = true;
		let re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
		if (inputData['password'] === undefined) {
			flag = false;
			setErrors((prev) => ({
				...prev,
				passwordError: 'Password Required!'
			}));
		} else if (inputData['password'] !== undefined && !re.test(inputData['password'])) {
			flag = false;
			setErrors((prev) => ({
				...prev,
				passwordError:
					'Password must contain 6 characters, at least one number, one lowercase and one uppercase letter'
			}));
		}
		if (inputData['passwordRe'] === undefined) {
			flag = false;
			setErrors((prev) => ({
				...prev,
				passwordReError: 'Required confirm password!'
			}));
		} else if (
			inputData['password'] !== undefined &&
			inputData['passwordRe'] !== undefined &&
			inputData['password'] !== inputData['passwordRe']
		) {
			flag = false;
			setErrors((prev) => ({
				...prev,
				passwordReError: "Passwords didn't match!"
			}));
		}
		return flag;
	};

	const resetValidation = (fieldName, value) => {
		if (value && fieldName) {
			let errorObj = { ...errors };
			if (fieldName in errorObj) {
				errorObj[fieldName] = undefined;
			}
			setErrors(errorObj);
		}
	};

	const onSubmit = async () => {
		let id = params.id;
		let { password, passwordRe } = inputData;
		if (validate()) {
			setLoading(true);
			let body = {};
			body.password = password;
			body.retypePassword = passwordRe;
			await ApiClient.PUT('changeUserPassword', body, id)
				.then(() => {
					onCloseModal();
					setLoading(false);
					toastSuccess('Updated successfully');
				})
				.catch(({ response }) => {
					setLoading(false);
					if (response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Something went wrong! Please try again.');
					}
				});
		}
	};

	const onChange = (e) => {
		let { name, value } = e.target;
		if (name !== null) {
			setInputData((prevState) => ({
				...prevState,
				[name]: value
			}));
			if (name === 'password') {
				setPassStrengthObj(checkPasswordStrength(value));
				resetValidation('passwordError', inputData.password);
			} else {
				resetValidation('passwordReError', inputData.passwordRe);
			}
		}
	};

	return (
		<Modal show={openModal} onHide={onCloseModal} centered>
			<div className="reset-password-popup add-color-popup">
				<Modal.Header closeButton>
					<h3 className="semibold-16 mb-0">Reset Password</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-lg-12">
							<div className="form-group mb-2">
								<label>Password*</label>
								<input
									className="bg-gray-light border-0"
									type="password"
									name="password"
									autoComplete="new-password"
									value={inputData?.password}
									onChange={onChange}
									placeholder="Enter Password"
								/>
								{errors?.passwordError ? (
									<span className="error">{errors?.passwordError}</span>
								) : (
									''
								)}
							</div>
							<ul className="password-hint my-2">
								<li style={{ fontSize: '12px' }}>
									* At least 6 Character & one number, Uppercase and lowercase
								</li>
							</ul>
							<div className="guide mb-1">
								<div className="bar">
									<div className="progress reset-password-progress">
										<div
											className="progress-bar"
											role="progressbar"
											style={{
												width: `${passStrengthObj.percentage}%`,
												backgroundColor: passStrengthObj.color
											}}
											aria-valuenow="75"
											aria-valuemin="0"
											aria-valuemax="100"
										></div>
									</div>
									<span>{passStrengthObj.text}</span>
								</div>
							</div>
						</div>
						<div className="col-lg-12">
							<div className="form-group">
								<label>Re-type password*</label>
								<input
									className="bg-gray-light border-0"
									type="password"
									name="passwordRe"
									value={inputData?.passwordRe}
									onChange={onChange}
									placeholder="Enter Password"
								/>
								{errors?.passwordReError ? (
									<span className="error">{errors?.passwordReError}</span>
								) : (
									''
								)}
							</div>
						</div>
					</div>
					<LoaderComponent loading={loading} />
				</Modal.Body>
				<Modal.Footer className="pt-0">
					<div className="popup-footer">
						<div className="buttons text-right">
							<button className="button gray-outline size32" onClick={onCloseModal}>
								Cancel
							</button>
							<button className="button size32 ml-2" onClick={onSubmit}>
								Submit{' '}
							</button>
						</div>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default ResetPassword;
